import { useTheme, Theme } from '@mui/material/styles';
import React from 'react';
import { RenderChildren } from '@/node-editor/components';
import { getSpacerValue } from '@/lib/utils/format';
import { INode, INodeProps } from '@/types/node';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { Box } from '@mui/material';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

const useStyles = (
  theme: Theme,
  { colSpacing, columns, verticalSpacing, override }
) => ({
  root: {
    display: 'grid !important',
    [`${theme.breakpoints.down('md')}`]: {
      gridTemplateColumns: `repeat(1, 1fr) !important`,
    },
    [`${theme.breakpoints.up('md')}`]: {
      gridTemplateColumns: `repeat(${columns}, 1fr) !important`,
    },
    gridGap: `${theme.spacing(colSpacing)}px !important`,
    width: '100% !important',
    paddingTop: `${theme.spacing(
      getSpacerValue(verticalSpacing.top)
    )}px !important`,
    paddingBottom: `${theme.spacing(
      getSpacerValue(verticalSpacing.bottom)
    )}px !important`,
    ...override.root,
  },
});

export const Render = ({
  node: {
    id,
    override,
    content: { colSpacing, columns, verticalSpacing },
  },
  children,
}: IProps) => {
  const theme = useTheme();
  const classes = useStyles(theme, {
    colSpacing,
    columns,
    verticalSpacing,
    override,
  });

  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      <RenderChildren>{children}</RenderChildren>
    </Box>
  );
};
